import { useQuery } from '@tanstack/react-query';
import { ApiError, requestJson } from './client';
import { authHeaders } from './regulations';

export interface ExportDataset {
  key: string;
  title: string;
  description: string;
  /** Сколько сотрудников попадёт в набор с вашими правами. */
  people: number;
  available: boolean;
}

export interface ExportCatalog {
  month: string;
  datasets: ExportDataset[];
}

/** Готовые сборки: набор галочек одним нажатием. */
export const EXPORT_PRESETS = [
  { key: 'timesheet', title: 'Табель за месяц', datasets: ['attendance-summary', 'attendance-days'] },
  { key: 'payroll', title: 'Расчёт зарплаты', datasets: ['payroll-month', 'deductions', 'salaries'] },
  {
    key: 'attendance',
    title: 'Всё по посещениям',
    datasets: ['attendance-summary', 'attendance-days', 'attendance-passes'],
  },
  { key: 'people', title: 'Сотрудники', datasets: ['employees'] },
] as const;

export function useExportCatalog() {
  return useQuery({
    queryKey: ['exports'],
    queryFn: () => requestJson<ExportCatalog>('/api/v1/exports'),
  });
}

/** Собирает файл и отдаёт его браузеру. */
export async function buildExport(input: { datasets: string[]; month: string; format: 'xlsx' | 'csv' }) {
  const response = await fetch('/api/v1/exports', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', 'x-goodway-csrf': '1', ...authHeaders() },
    body: JSON.stringify(input),
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: { message?: string } } | null;
    throw new ApiError(response.status, 'BAD_REQUEST', body?.error?.message ?? 'Файл не собрался');
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `goodway-${input.month}.${input.format}`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
  return blob.size;
}
